<script setup lang="ts">
import type { Vendor } from '../../types/vendor';

const props = withDefaults(
    defineProps<{
        vendor?: Vendor;
        target?: '_blank' | '_self';
    }>(),
    {
        vendor: undefined,
        target: '_self',
    },
);

// IDS-160
const { getCategoryLink } = useVendor();
const categoryLink = computedAsync(async () => await getCategoryLink(props.vendor?.id), null);
</script>

<template>
    <template v-if="vendor">
        <LocaleLink
            v-if="categoryLink"
            :aria-label="vendor.translated.name"
            :to="categoryLink"
            :target="target"
            class="underline"
        >
            {{ vendor.translated?.name }}
        </LocaleLink>

        <template v-else>
            {{ vendor.translated?.name }}
        </template>
    </template>
</template>
